import { inject, Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { ToolbarService } from '../../../services/toolbar.service';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { EstimagePayInvoice, EstimagePayInvoicesPayload } from './estimage-pay-invoices.model';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../../../services/user.service';

export type EstimagePayFactoredInvoicesState = {
  isLoading: boolean;
  pagedInvoices: EstimagePayInvoice[];
  totalInvoiceCount: number;
};

const initialState: EstimagePayFactoredInvoicesState = {
  isLoading: true,
  pagedInvoices: [],
  totalInvoiceCount: null
};

export type SortedPagedRequest = {
  pageIndex: number;
  // sortOrder: 'asc' | 'desc' | '';
  // sortColumn: string;
};

const initialSortedPagedRequest: SortedPagedRequest = {
  pageIndex: 0
  // sortOrder: 'desc',
  // sortColumn: 'acceptedOrRejectedDateTime'
};

@Injectable()
export class EstimagePayInvoicesStore extends ComponentStore<EstimagePayFactoredInvoicesState> {
  toolbarService = inject(ToolbarService);
  userService = inject(UserService);

  isLoading = this.selectSignal((state) => state.isLoading);
  pagedInvoices = this.selectSignal((state) => state.pagedInvoices);
  totalInvoiceCount = this.selectSignal((state) => state.totalInvoiceCount);

  constructor() {
    super(initialState);
    this.getInvoices(initialSortedPagedRequest);
  }

  getInvoices = this.effect((request$: Observable<SortedPagedRequest>) => {
    return request$.pipe(
      tap(() => {
        this.toolbarService.setCloudState('FETCHING');
        this.patchState({ isLoading: true });
      }),
      switchMap((request: SortedPagedRequest) =>
        this.userService.getEstimagePayFactoredInvoices(request).pipe(
          tapResponse({
            next: (payload: EstimagePayInvoicesPayload) => {
              this.patchState({
                pagedInvoices: payload.invoices,
                totalInvoiceCount: payload.invoiceCount
              });
            },
            error: (err: HttpErrorResponse) => console.error({ err }),
            finalize: () => {
              this.toolbarService.setCloudState('RESTING');
              this.patchState({ isLoading: false });
            }
          })
        )
      )
    );
  });
}
